<div class="status-container col-lg-3">
    <div [ngClass]="hasSeparator ? 'separator' : 'invisible-separator'"></div>
    <div class="status-card">
        <div class="body flex-row">
            <div class="img mx-auto text-center">
                <img
                    appImageSelector
                    alt="mt-image"
                    [imageType]="'dashboard-' + machineType"
                    [imageKey]="imageName"
                />
            </div>
        </div>
        <div class="row footer" [ngStyle]="{ color: summaryStatus.color }">
            <div class="col-md-12">
                <div class="percent">{{ summaryStatus.percentage }}%</div>
            </div>
            <div class="col-md-12">
                <div class="status-name">
                    <div class="status-title">{{ "status" | lang }}</div>
                    <div class="status">
                        {{ summaryStatus.statusName | lang }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
